const CurrencyFragment = `
    id
    code
`

export default CurrencyFragment
